import { Global, css } from "@emotion/react";
import React from "react";
import useDjangoWaffle from "@shared/hooks/djangoWaffle/useDjangoWaffle";
import { CaptchaBadgeStylerProps } from "@ui-application/other/CaptchaBadgeStyler/CaptchaBadgeStyler.props";
import Text from "@ui-kit/typography/Text/Text.web";
import Link from "@ui-kit/navigation/Link/Link.web";

/**
 * The Google reCAPTCHA script is loaded into the app when a component that utilizes the captcha check
 * renders, however instead of unloading and loading the script again when the captcha check is required
 * we just always set the reCAPTCHA badge to hidden to avoid covering important areas of the app.
 * To adhere to Google's terms and conditions we can use this component to set the badge to visible when needed.
 */

const CaptchaBadgeStyler: React.FC<CaptchaBadgeStylerProps> = ({
  forceVisible = false,
  textOnly = false,
}) => {
  const { SWITCHES } = useDjangoWaffle();

  if (!forceVisible && !SWITCHES.enable_captcha) return null;

  return (
    <>
      {textOnly && (
        <Text size="sm" color="gray.600">
          This site is protected by reCAPTCHA and the Google
          <Link
            size="sm"
            mx="3xs"
            external
            target="_blank"
            rel="noreferrer"
            href="https://policies.google.com/privacy"
          >
            Privacy Policy
          </Link>
          and
          <Link
            size="sm"
            mx="3xs"
            external
            target="_blank"
            rel="noreferrer"
            href="https://policies.google.com/terms"
          >
            Terms of Service
          </Link>
          apply.
        </Text>
      )}

      {!textOnly && (
        <Global
          styles={css`
            .grecaptcha-badge {
              visibility: visible !important;
            }
          `}
        />
      )}
    </>
  );
};

export default CaptchaBadgeStyler;
